import React , { useState , useEffect }from 'react';
import webapi from '../../../api/webapi';
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import Loading from '../modal/Loading';

const Books =(props) => {
    //const [statments,setStatments] = useState(undefined);
    const [languageInfo, setLanguageInfo] = useState(undefined);
    const [pageData, setPageData] = useState(undefined);
    const [allBooks, setAllBooks] = useState(undefined);

    useEffect(()=>{
        async function getlanguageInfo(){
            var languageCode;
            var responseResultLanguageinfo
            if (new URLSearchParams(props.location.search).get("lang")!=null)
            {
                //console.log('langFromURL: ',new URLSearchParams(props.location.search).get("lang"));
                //console.log('langFromSubDomain: ',window.location.host.split(".")[0]);
                languageCode = new URLSearchParams(props.location.search).get("lang");
                responseResultLanguageinfo = await webapi.get('pages/languageInfo/'+languageCode);
                //console.log(languageInfo);
            }else{
                responseResultLanguageinfo = {data:[{Code:"fa",Title:"فارسی",Direction:"rtl"}]};
            }
            
            // console.log(responseResultLanguageinfo.data.length);
            // console.log(responseResultLanguageinfo.data);
            
            if (responseResultLanguageinfo && responseResultLanguageinfo.data && responseResultLanguageinfo.data.length>0){
                setLanguageInfo(responseResultLanguageinfo.data);
                //setState({lang : responseResultLanguageinfo.data[0].Code});
                document.getElementsByTagName('html')[0].setAttribute("lang", responseResultLanguageinfo.data[0].Code);
                document.getElementsByTagName('html')[0].setAttribute("dir", responseResultLanguageinfo.data[0].Direction);
            }
        }

        getlanguageInfo ();

        //getPage();
        //fetch('https://api.ipify.org/?format=json')
        // fetch('https://geolocation-db.com/json/')
        //     .then(response => {
        //         return response.json();
        //     }, "jsonp")
        //     .then(res => {
        //         setLog('pages/log/books_'+props.match.params.bookgroupcode+'/visit/'+res.IPv4.replaceAll('.',','))
        //     })
        //     .catch(err => setLog('pages/log/books_'+props.match.params.bookgroupcode+'/visit/'+err));
    },[props.location.search])


    useEffect(()=>{
        async function getPage() {

            if (languageInfo)
            {
                const pageList = await webapi.get('pages/datapages/301/'+languageInfo[0].Code);
                //console.log(pageList);
                setPageData(pageList.data);
            }else{
                const pageList = await webapi.get('pages/datapages/301/fa');
                //console.log(pageList);
                setPageData(pageList.data);
            }

            //var AllBooksConst
            //console.log('1234567');
            //console.log('bookgroupcode0:',props.match.params.bookgroupcode);
            if (props.match.params.bookgroupcode)
            {
                if (languageInfo)
                {
                    //console.log('book/booksofbookgroup/'+props.match.params.bookgroupcode+'/'+languageInfo[0].Code);
                    await webapi.get('book/booksofbookgroup/'+props.match.params.bookgroupcode+'/'+languageInfo[0].Code)
                    .then ((res)=> {
                        //console.log('AllBooksConst:',a)
                        if(res.data) setAllBooks(res.data)
                    })
                }   
                // setState({
                //     BookGroupTitle: AllBooksConst.data[0].Title
                // });
            }
            else
            {
                if (languageInfo)
                {
                    await webapi.get('book/allbooks/'+languageInfo[0].Code)
                    .then ((res)=> {
                            //console.log('AllBooksConst:',a)
                            if(res.data) setAllBooks(res.data)
                        })
                    //console.log('AllBooksConst3:',AllBooksConst);
                    //setAllBooks(AllBooksConst.data);
                }
            }
            //console.log(AllBooks);
        }

        getPage();
    },[languageInfo,props.match.params.bookgroupcode])

    // async setLog(Data) {
    //     await webapi.post(Data);
    // }

    if (pageData && languageInfo) {
        return  (
            <div>
                <Header languageInfo = {languageInfo}/>
                <div className="container-fluid" id="innerpage_row_1">
                    <div className="container">
                        {
                            props.match.params.bookgroupcode === '1'
                            ?
                            <h1 id="page_title">{pageData.length!==0 && pageData[0].F39905!== undefined?pageData[0].F39905:39905/*متون زرتشتی */}</h1>
                            :
                            <h1 id="page_title">{pageData.length!==0 && pageData[0].F39904!== undefined?pageData[0].F39904:39904/*کتیبه های خصوصی */}</h1>
                        }
                    </div>
                </div>
                {
                    (allBooks)
                    ?
                    <div className="container-fluid">
                        <div className="container container_70">
                            <table className="table_style">
                                <thead>
                                    <tr>
                                        <th>{pageData.length!==0 && pageData[0].F39901!== undefined?pageData[0].F39901:39901/*ردیف*/}</th>
                                        <th>{pageData.length!==0 && pageData[0].F39902!== undefined?pageData[0].F39902:39902/*نام*/}</th>
                                        <th>{pageData.length!==0 && pageData[0].F39903!== undefined?pageData[0].F39903:39903/*وضعیت بارگذاری*/}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        (allBooks && allBooks.length>0)
                                        ?
                                            allBooks.map((book) =>{
                                                return  (
                                                    <tr key= {book.Code}>
                                                        <td>
                                                            <p className="book_number">
                                                                <span className="circle">
                                                                    {book.Code}
                                                                </span>
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <p className="book_title">
                                                                { 
                                                                    book.HyperLinked===1
                                                                    ?
                                                                    <a href={process.env.PUBLIC_URL+"/book/"+book.Code+"?lang="+languageInfo[0].Code}>
                                                                        {book.Title}
                                                                    </a>
                                                                    :
                                                                    book.Title
                                                                }
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <p className="book_stat">
                                                                {book.Description}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        :
                                        null
                                    }
                                </tbody>
                            </table>                                 
                        </div>
                    </div>
                    :
                    <div>
                        <div style={{height:"400px",width:"100%", clear:"both"}}></div>
                        <Loading loadingShow={true} />
                    </div>
                }
                <Footer  Lang = {languageInfo[0].Code}/>
            </div>  
        )
    }
    else
    {
        return null
    }
 }

 export default Books;